import { z } from 'zod';

export const notificationSettingsScheme = z.object({
  IsNotDisturbAll: z.number().pipe(z.coerce.boolean()),
  IsNotMessageDisturb: z.number().pipe(z.coerce.boolean()),
  IsNotCallDisturb: z.number().pipe(z.coerce.boolean()),
  IsNotSound: z.number().pipe(z.coerce.boolean()),
  IsNotVibration: z.number().pipe(z.coerce.boolean()),
});

export type NotificationSettings = z.infer<typeof notificationSettingsScheme>;
